export default __webpack_public_path__ + "static/media/hipaa-privacy-standards.88031b93.svg";